import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Loader from "../../LoaderNew/Loader";
import { makeStyles, Tooltip, Typography, withStyles } from "@material-ui/core";
import {
  changeCurrentPage,
  changeRowsPerPage,
} from "../../../actions/audit_logs_actions";

import LogDetailsDialog from "./DetailsDialog";
import TablePagination from "@material-ui/core/TablePagination";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "red",
    "& *": {
      userSelect: "text", // Allow text selection
    },
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    direction: "rtl",
  },
  container: {
    maxHeight: "calc(100vh - 160px)",
    direction: "ltr",
  },
  pagination: {
    direction: "ltr",
  },
}));

const StyledHeadCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#243748",
    color: theme.palette.common.white,
    left: "unset",
  },
  body: {
    fontSize: 14,
    fontFamily: "Rubik",
  },
}))(TableCell);

function TableHeadOrg(props) {
  const classes = useStyles();
  return (
    <TableHead>
      <TableRow>
        <StyledHeadCell
          component="th"
          scope="row"
          key={"source"}
          align={"source"}
        >
          <div className={classes.headCell}>{"source"}</div>
        </StyledHeadCell>
        <StyledHeadCell
          component="th"
          scope="row"
          key={"message"}
          align={"action"}
        >
          <div className={classes.headCell}>{"message"}</div>
        </StyledHeadCell>
        <StyledHeadCell component="th" scope="row" key={"action"}>
          <div className={classes.headCell}>{"action"}</div>
        </StyledHeadCell>
        <StyledHeadCell component="th" scope="row" key={"timestamp"}>
          <div className={classes.headCell}>{"timestamp"}</div>
        </StyledHeadCell>
        <StyledHeadCell component="th" scope="row" key={"user"}>
          <div className={classes.headCell}>{"user"}</div>
        </StyledHeadCell>
        <StyledHeadCell component="th" scope="row" key={"factory"}>
          <div className={classes.headCell}>{"factory"}</div>
        </StyledHeadCell>
      </TableRow>
    </TableHead>
  );
}

export default function TableAuditLogs(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { list, countLogs } = props;

  const [idCurrent, setIdCurrent] = React.useState(undefined);

  const page = useSelector((state) => state.auditLogs.currentPage);
  const loading = useSelector((state) => state.auditLogs.loading);
  const rowsPerPage = useSelector((state) => state.auditLogs.rowsPerPage);

  const handleEdit = (id) => {
    setIdCurrent(id);
  };

  const handleClose = () => {
    setIdCurrent(null);
  };

  const handleChangePage = (event, newPage) => {
    dispatch(changeCurrentPage(newPage));
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(changeRowsPerPage(parseInt(event.target.value, 10)));
  };

  return (
    <div className={classes.root}>
      <LogDetailsDialog
        isOpen={!!idCurrent}
        onClose={handleClose}
        id={idCurrent}
      />
      <Paper className={classes.paper}>
        <TableContainer component={Paper} className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
          >
            <TableHeadOrg />
            <TableBody>
              {loading && <Loader />}
              {list &&
                list.map((element) => {
                  return (
                    <TableRow
                      style={{ height: 33 }}
                      hover
                      tabIndex={-1}
                      key={element._id}
                      onClick={() => handleEdit(element._id)}
                    >
                      <TableCell
                        dir={"ltr"}
                        component="th"
                        scope="row"
                        key={"source"}
                      >
                        {element.ip}  {element.user_agent}
                      </TableCell>

                      <TableCell
                        dir={"ltr"}
                        component="th"
                        scope="row"
                        key={"message"}
                      >
                        {element.message}
                      </TableCell>

                      <TableCell
                        component="th"
                        scope="row"
                        key={"action"}
                        style={{ textTransform: "uppercase" }}
                      >
                        {element.linked_class} {element.action}
                      </TableCell>

                      <TableCell component="th" scope="row" key={"timestamp"}>
                        {element.timestamp}
                      </TableCell>
                      <Tooltip title={element?.user?.full_name}>
                        <TableCell component="th" scope="row" key={"timestamp"}>
                          {element?.user?.email}
                        </TableCell>
                      </Tooltip>
                      <TableCell component="th" scope="row" key={"factory"}>
                        {element?.factory?.name}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        {!loading && list.length === 0 && (
          <Typography
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            No Items available
          </Typography>
        )}
        <TablePagination
          className={classes.pagination}
          rowsPerPageOptions={[5, 10, 20]}
          component="div"
          colSpan={3}
          count={countLogs}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: { "aria-label": "rows per page" },
            native: false,
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
